/**
 * Log Error message in console.
 *
 * @param args - The warning message to log.
 */
const warn = (...args) => {
    // We are intentionally logging the message in console
    // eslint-disable-next-line no-console
    console.warn(...args);
};
export default warn;
//# sourceMappingURL=warn.js.map